/**
 * Returns pathname for reliable comparisons (excluding query params).
 * @param urlOrPath URL string
 * @returns pathname
 */
export const getPathname = (urlOrPath: string): string => {
	const url = new URL(urlOrPath, window.location.origin);
	return url.pathname;
};
